const localStorageConstant = {
  UNAUTHENTICATED_INFO : "unAuthenticatedInfo",
  IS_SHOW_UNAUTHENTICATED_SNACKBAR : "showUnAuthenticatedSnackbar",
  IS_SHOW_RESULT_HINT : "showResultHint",
  FIFTEEN_MINUTES : 900//seconds
}
export default localStorageConstant
